import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Globe, Search, Database, ClipboardList, SearchCodeIcon, Mail, AxeIcon, GemIcon, SearchCheckIcon, HandIcon, PlusIcon, AwardIcon, WifiIcon } from "lucide-react";

interface Service {
  icon: any;
  title: string;
  description: string;
  features: string[];
  color: string;
  link?: string;
}

const services: Service[] = [
  {
    icon: Globe,
    title: "Generación de Landing Pages",
    description: "Diseñamos landing pages modernas y optimizadas para convertir visitantes en clientes. Diseño responsive, carga rápida y enfocadas en resultados.",
    features: ["Diseño personalizado", "Optimización móvil", "Alta conversión", "Integración analytics"],
    color: "bg-blue-500/10 text-blue-600",
    link: "/soluciones-empresariales"
  },
  {
    icon: Search,
    title: "Optimización SEO",
    description: "Mejoramos el posicionamiento de tu sitio web en buscadores. Análisis técnico, contenido optimizado y estrategias de link building.",
    features: ["Auditoría SEO", "Keywords research", "SEO técnico", "Reportes mensuales"],
    color: "bg-green-500/10 text-green-600"
  },
  {
    icon: Database,
    title: "Proyectos en Laravel - Symfony - PHP",
    description: "Desarrollo de aplicaciones web robustas y escalables con Laravel. APIs RESTful, sistemas de gestión y soluciones empresariales.",
    features: ["APIs RESTful", "Paneles admin", "Integraciones", "Código limpio","MariaDB/MySQL"],
    color: "bg-purple-500/10 text-purple-600",
    link: "/soluciones-empresariales"
  },
  {
    icon: AwardIcon,
    title: "WordPress - WooCommerce - Drupal - Prestashop - FilamentPHP",
    description: "Desarrollo de gestores de contenidos robustas y escalables con Wordpress o Drupal. sistemas de gestión y soluciones empresariales. Paneles admin personalizados, integraciones a medida y código limpio para proyectos de cualquier tamaño.",
    features: ["Admin panel",  "Código limpio","MariaDB/MySQL", "WordPress", "WooCommerce", "Drupal", "Prestashop", "Filamentphp"],
    color: "bg-purple-500/10 text-purple-600",
    link: "/soluciones-empresariales"
  },
  {
    icon: ClipboardList,
    title: "Análisis de Requerimientos",
    description: "Toma de requerimientos profesional para proyectos de larga duración. Documentación detallada, planificación y seguimiento continuo.",
    features: ["Levantamiento de información", "Documentación", "Roadmap proyecto", "Gestión ágil"],
    color: "bg-orange-500/10 text-orange-600"
  },

  {
    icon: GemIcon,
    title: "ODOO Implementación y Desarrollo",
    description: "Desarrollo e implementación de soluciones ODOO adaptadas a las necesidades de tu negocio. Módulos personalizados, integración y soporte continuo.",
    features: ["Python", "Documentación", "Proyectos para tu PYME", "Gestión ágil","Sqlite/PostgreSQL"],
    color: "bg-orange-500/10 text-orange-600"
  },

  {
    icon: Mail,
    title: "Inbound Marketing",
    description: "Estrategias de marketing enfocadas en atraer clientes potenciales mediante contenido valioso y experiencia positiva.",
    features: ["Estrategia de contenido", "Automatización de marketing", "Análisis de datos", "Mejora de conversión"],
    color: "bg-orange-500/10 text-orange-600",
    link: "/inbound-marketing"
  },
  {
    icon: WifiIcon,
    title: "Apps Móviles",
    description: "Desarrollo de aplicaciones móviles nativas e híbridas para iOS y Android.",
    features: ["Desarrollo nativo", "Apps híbridas", "Integración con APIs", "IOS y Android","Swift", "SwiftUI", "Kotlin", "Flutter"],
    color: "bg-orange-500/10 text-orange-600",
    link: "/desarrollo-movil"
  }
  
];

const ServicesSection = () => {
  return (
    <section id="servicios" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge variant="secondary" className="mb-4">Nuestros Servicios</Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Soluciones integrales para tu negocio
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Ofrecemos un conjunto completo de servicios de desarrollo y consultoría 
            para llevar tu proyecto al siguiente nivel.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {services.map((service, index) => {
            const CardWrapper = service.link ? 'a' : 'div';
            const cardProps = service.link
              ? { href: service.link, className: "block" }
              : {};

            return (
              <CardWrapper key={index} {...cardProps}>
                <Card
                  className={`group hover:shadow-lg transition-all duration-300 border-border/50 hover:border-primary/30 h-full ${service.link ? 'cursor-pointer' : ''}`}
                >
                  <CardHeader>
                    <div className={`w-12 h-12 rounded-lg ${service.color} flex items-center justify-center mb-4`}>
                      <service.icon className="w-6 h-6" />
                    </div>
                    <CardTitle className="text-xl group-hover:text-primary transition-colors">
                      {service.title}
                      {service.link && (
                        <span className="ml-2 text-primary text-sm">→</span>
                      )}
                    </CardTitle>
                    <CardDescription className="text-muted-foreground">
                      {service.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="flex flex-wrap gap-2">
                      {service.features.map((feature, idx) => (
                        <Badge key={idx} variant="outline" className="text-xs">
                          {feature}
                        </Badge>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              </CardWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
